let items = document
  .querySelector(".header__inline-menu")
  .querySelectorAll("details");
items.forEach((item) => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    item.querySelector("summary").setAttribute("aria-expanded", "true");
    item.addEventListener("mouseout", () => {
      item.removeAttribute("open");
      item.querySelector("summary").setAttribute("aria-expanded", "false");
    });
  });
});

items.forEach((item) => {
  const summary = item.querySelector("summary");

  let tappedOnce = false;

  summary.addEventListener("click", (e) => {
    if (window.innerWidth <= 768) {
      if (!item.hasAttribute("open")) {
        e.preventDefault();
        item.setAttribute("open", true);
        summary.setAttribute("aria-expanded", "true");
      } else {
        item.removeAttribute("open"); 
        summary.setAttribute("aria-expanded", "false");
      }
    }
  });
});